module.exports = __webpack_public_path__ + "01ea978f/img/verified-icon.f93bbc14.svg";